<app-header-page>
    <app-component-button-header-back [href]="'/account/production/cards/' + puid">
        Оригинальная карточка
    </app-component-button-header-back>
</app-header-page>

<div class="row rounded-3 gbo_shadow m-0 h-80 bg-white"
     *ngIf="publicCard"
>
    <div class="col-3 border-end p-2">
        <div class="position-relative m-2"
             style="width: 400px; height: 400px;"
        >
            @if (publicCard.photo_first) {
                <img [src]="publicCard.photo_first.originImage"
                     alt="#"
                >
            } @else {
                <img ngSrc="../../../../assets/images/placeholders/no_image.jpg"
                     alt="#"
                     height="400"
                     width="400"
                >
            }
        </div>
        @if (publicCard.photo_first) {
            <div class="position-relative m-1 carousel">
                @for (photo of publicCard.photos; track photo) {
                    <div style="width: 80px; height: 80px;"
                         class="carousel_item">
                        <img style="position: unset;"
                             [src]="photo.originImage"
                             alt="#"
                        >
                    </div>
                }
            </div>
        }
        <div>
            <button class="btn btn-success mt-2"
                    (click)="modalService.openTemplateModal(addProductCardPhoto)"
            >
                Добавить изображение
            </button>
        </div>
    </div>

    <div class="col-6 border-end p-4">
        <h2>
            Название:
            <app-component-input-inline
                    [value]="publicCard.title"
                    [editByPen]="true"
            ></app-component-input-inline>
            <!--            (emitSave)="editCard($event, 'title')"-->
        </h2>

        <p *ngIf="publicCard.original.author">
            Автор:
            <span class="user_profile"
                  (click)="helpers.openProfileByGuid(publicCard.original.author.guid)"
            >
                {{ helpers.shortFullName(publicCard.original.author) }}
            </span>
        </p>
        <p>
            Создан: {{ helpers.formatDate(publicCard.created_at) }}
        </p>

        <div class="mt-1">
            <h2>Описание:</h2>
            <app-component-ckeditor [inputData]="publicCard.description"
            ></app-component-ckeditor>
            <!--            (emitFinish)="editCard($event[1], 'description')"-->
        </div>
        <div>
            <h2>Оформление партии</h2>
            <div>
                <button class="btn btn-sm btn-success me-2"
                        [class.d-none]="batchCounterValue === 0"
                        style="width: 50px;"
                        (click)="batchCounterValue = batchCounterValue - 1"
                >
                    <i class="bi bi-dash"></i>
                </button>
                <input type="number"
                       style="width: 60px;"
                       [value]="batchCounterValue"
                       (click)="batchCounter.value = null; batchCounterValue = null"
                       (change)="batchCounterValue = batchCounter.value"
                       #batchCounter
                >
                <button class="btn btn-sm btn-success ms-2"
                        style="width: 50px;"
                        (click)="batchCounterValue = batchCounterValue + 1"
                >
                    <i class="bi bi-plus"></i>
                </button>
            </div>
            <div>
                <h2>Цена за единицу:</h2>
                <input type="number"
                       style="width: 60px;"
                       (change)="price = priceInput.value"
                       #priceInput
                >
            </div>
            <div class="btn-group mt-1">
                <button class="btn btn-success"
                        (click)="addBatchToNewCargo()"
                >
                    <span>Создать партию в новый груз</span> <i class="bi bi-bag-check ms-1"></i>
                </button>
                <button class="btn btn-success"
                        (click)="openCargoModal(selectCargoModal)"
                >
                    <span>Создать партию в существующий груз</span> <i class="bi bi-bag-check ms-1"></i>
                </button>
            </div>
        </div>

        <mat-tab-group class="mt-2">
            <mat-tab>
                <ng-template mat-tab-label>
                    <strong>Комментарии</strong>
                </ng-template>
                <ng-template matTabContent>
                    комменты тут
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <strong>Коллекции документов</strong>
                </ng-template>
                <ng-template matTabContent>
                    <button class="btn btn-success mb-3 mt-3"
                            (click)="modalService.openTemplateModal(collectionView, 'xl')"
                    >
                        Добавить коллекцию
                    </button>

                    <mat-accordion [displayMode]="'flat'">
                        @for (collection of publicCard.collections; track collection.id) {
                            <mat-expansion-panel class="accordion-item"
                                                 [togglePosition]="'before'"
                                                 (opened)="openCollectionAccordion(collection.id)"
                            >
                                <mat-expansion-panel-header
                                        [collapsedHeight]="'48px'"
                                        [expandedHeight]="'48px'"
                                >
                                    <mat-panel-title>
                                        {{ collection.name }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div>
                                    <strong>
                                        {{ collection.name }}
                                    </strong>
                                    <div [innerHTML]="collection.description"></div>

                                    <div style="margin: 15px 0;">
                                        <app-component-folder-and-file-table
                                                (eventFind)="onEventFind($event)"
                                                (eventClick)="onEventClick($event, viewDocument)"
                                                [$mediator]="controller.$mediator"

                                                [isNeedRefreshMediator]="true"
                                                [showBackButton]="false"
                                        ></app-component-folder-and-file-table>
                                    </div>

                                    <button class="btn btn-danger"
                                            (click)="removeCollection(collection.id)"
                                    >
                                        <lucide-icon class="me-1"
                                                     size="16"
                                                     name="trash-2"
                                                     [strokeWidth]="1.2"
                                        ></lucide-icon>
                                        <span>Удалить</span>
                                    </button>
                                </div>
                            </mat-expansion-panel>
                        }
                    </mat-accordion>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div class="col-3 p-2">
        <strong>Партии товара:</strong>
        <div class="list-group">
            @for (batch of allBatches; track batch.ps_party_key) {
                <a class="list-group-item list-group-item-action">
                    <strong>cargo_key: </strong>{{ batch.cargo_key }}<br>
                    <strong>created_at: </strong>{{ batch.created_at | date:'HH:mm dd.MM.yyyy' }}<br>
                    <strong>product_count: </strong>{{ batch.product_count }}<br>
                    <strong>product_count_type: </strong>{{ batch.product_count_type }}<br>
                    <strong>product_price: </strong>{{ batch.product_price }}<br>
                    <strong>product_puid: </strong>{{ batch.product_puid }}<br>
                    <strong>ps_party_key: </strong>{{ batch.ps_party_key }}<br>
                </a>
            }
        </div>
    </div>
</div>

<!--TODO тут кнопки-->
<!--<div class="input-count-block">-->
<!--    <i class="ri-subtract-line"></i>-->
<!--    <input type="number">-->
<!--    <i class="ri-add-line"></i>-->
<!--</div>-->
<!--<div>-->
<!--    <button mat-flat-button-->
<!--            class="main-content-button apply"-->
<!--    >-->
<!--        <i class="ri-checkbox-fill"></i>-->
<!--        <span>Купить</span>-->
<!--    </button>-->
<!--    <button mat-flat-button-->
<!--            class="main-content-button cancel"-->
<!--    >-->
<!--        <i class="ri-close-fill"></i>-->
<!--        <span>Добавить в избранное</span>-->
<!--    </button>-->
<!--</div>-->

<ng-template #addProductCardPhoto
             let-modal
>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>Фотография</h2>
        <input type="file"
               class="form-control"
               id="customFile"
               multiple
               accept="image/*"
               (change)="viewImageUpload($event)"
               #files>


        <div class="img-table mt-3">
            <div class="img-card"
                 *ngFor="let preview of previews; let i = index"
            >
                <img class="preview-image"
                     [src]="preview"
                     (click)="removeImage(files, i)"
                     alt="#">
                <!--                <img class="hover-image" src="../../../../assets/images/icons/x-square.svg" alt="#">-->
            </div>
        </div>

        <button class="btn btn-success mt-2"
                (click)="addNewPhotos(modal)"
        >
            Сохранить
        </button>
    </div>
</ng-template>

<ng-template #selectCargoModal
             let-modal
>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>Выбрать груз</h2>
        <select class="mt-2"
                #cargoSelect
        >
            <option selected
                    hidden
                    value=""
            >
                Выбрать груз
            </option>
            @for (cargo of allCargos; track cargo.ps_cargo_key) {
                <option [value]="cargo.ps_cargo_key">
                    {{ cargo.ps_cargo_key }}
                </option>
            }
        </select>

        <button class="btn btn-success mt-1"
                (click)="addBatchToExistCargo(cargoSelect.value, modal)"
        >
            Добавить
        </button>
    </div>
</ng-template>

<ng-template #collectionView
             let-modal>
    <app-button-modal-close [modalSize]="'xl'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-component-file-navigator
                (eventSelected)="selectCollection($event[0])"
                (eventSubmit)="addCollection(modal)"
                selectedType="collection"
        ></app-component-file-navigator>
    </div>
</ng-template>

<ng-template #viewDocument
             let-modal
>
    <app-button-modal-close (closeEmit)="documentKey = ''"
                            [modal]="modal"
                            modalSize="xl"
    ></app-button-modal-close>
    <div class="modal-body">
        <app-component-doc-view
                [fileUkey]="documentKey"
        ></app-component-doc-view>
    </div>
</ng-template>
